import React from 'react';
import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';
export const ViewMoreArrow = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '14',
    height: props.height || '11',
    fill: props.fill || '#E35205',
  };
  return (
    <svg viewBox="0 0 14 11" {...svgProps} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.125 5.49194C13.1207 5.0316 12.9353 4.59148 12.6087 4.26694L8.855 0.504444C8.69106 0.341474 8.46929 0.25 8.23812 0.25C8.00696 0.25 7.78519 0.341474 7.62125 0.504444C7.53924 0.585786 7.47414 0.682562 7.42972 0.789189C7.3853 0.895816 7.36243 1.01018 7.36243 1.12569C7.36243 1.2412 7.3853 1.35557 7.42972 1.4622C7.47414 1.56883 7.53924 1.6656 7.62125 1.74694L10.5 4.61694H1.75C1.51794 4.61694 1.29538 4.70913 1.13128 4.87323C0.967187 5.03732 0.875 5.25988 0.875 5.49194C0.875 5.72401 0.967187 5.94657 1.13128 6.11066C1.29538 6.27476 1.51794 6.36694 1.75 6.36694H10.5L7.62125 9.2457C7.45648 9.4093 7.36346 9.63166 7.36264 9.86385C7.36182 10.096 7.45327 10.3191 7.61687 10.4838C7.78048 10.6486 8.00284 10.7416 8.23503 10.7424C8.46723 10.7433 8.69023 10.6518 8.855 10.4882L12.6087 6.72569C12.9374 6.39901 13.123 5.95532 13.125 5.49194Z"
        fill={svgProps.fill}
      />
    </svg>
  );
};

ViewMoreArrow.iconType = ICON_TYPES.VIEW_MORE_ARROW_ICON;
